module.exports = __webpack_public_path__ + "img/ic_minus_14.0ea9f4c7.svg";